export var giftWrappingConfigEndpoint = '/public-api/gift-wrapping/configuration';
